import AppTour from './app-tour';

export default AppTour;
